import axios from 'axios';

class Api {
  constructor() {
    this.processing = false;
    this.search_url = '/countries/search?q=';
    this.all_url = '/countries/all';
  }

  all() {
    return this.request(this.all_url, null);
  }

  search(query) {
    return this.request(this.search_url, query);
  }

  request(url, query) {
    this.processing = true;

    return new Promise((resolve, reject) => {
      axios
        .get(url + (query ? query : ''))
        .then(response => {
          this.processing = false;
          resolve(response.data);
        })
        .catch(error => {
          this.processing = false;
          reject(error.response);
        });
    });
  }
}

export default Api;
